import { createContext, useContext } from 'react';
import { useRadarLocale } from '@/i18n/RadarLocaleContext';

// Shared by the single and batch Gmail export controls, default off.
export const EmailSignalExportContext = createContext(false);
export function RadarEmailSignalNotice() {
  const enabled=useContext(EmailSignalExportContext);
  const {t}=useRadarLocale();
  return enabled ? <p className="radar-muted">{t('New exports include a tracking image when open signals are enabled. Use the connected sending address; send-as aliases cannot be checked yet.')}</p> : null;
}
